import { inject, observer } from 'mobx-react';
import QuickFilter from '../Common/QuickFilter';
import appConstants from '../../../appConstants';
import { useEffect } from 'react';
import { getDataWithQueryString } from '../../../api/componentAPIs';
import { withUserProfile } from '../../../userProfile/userProfileContext';

const ShipmentForecastQuickFilter = (props) => {
  useEffect(() => {
    if(props.IBPlanningStore.quickFilterList.length === 0) {
      loadQuickFilters();
    }
  }, []);

  const loadQuickFilters = () => {
    getDataWithQueryString(
      'GetQuickFilters',
      `terminalId=${props.userData.userProfile.terminal.id}`
    ).then(
      (response) => {
        if (response.status === 200) {
          props.IBPlanningStore.updateQuickFilterList(response.data);
        } else {
          props.IBPlanningStore.updateQuickFilterList([]);
        }
      },
      (error) => {
        props.IBPlanningStore.updateQuickFilterList([]);
      }
    );
  };

  return (
    <QuickFilter
      filterName={appConstants.IBPLANNING_QUICKFILTER_NAMES.SHIPMENT_FORECAST}
      key={appConstants.IBPLANNING_QUICKFILTER_NAMES.SHIPMENT_FORECAST}
      {...props}
    />
  );
};

export default inject('IBPlanningStore')(observer(withUserProfile(ShipmentForecastQuickFilter)));
